import classes from './Form.module.scss' ;
import useInput from '../Hooks/Use-Input';
import React, { useRef , useState} from 'react';
import emailjs from '@emailjs/browser';
import { FaFacebookF } from "react-icons/fa";
import  contactImg  from '../assets/contactImg.png';
import { FaWhatsapp } from "react-icons/fa";
// import { FaMobileAlt } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import {Container , Row , Col  } from 'react-bootstrap' 
import { FaLinkedinIn } from "react-icons/fa"; 
import { FaYoutube } from "react-icons/fa";
import {range} from '../Utility/Consts' ;
import {ContactChannel} from '../Utility/Consts' ;
import {Products} from '../Utility/Consts' ;
//-------------------------------- whatsapp
const whatsapp  = 'https://api.whatsapp.com/send?phone=201277773615' ;

const   Form = ({ order=false}) => {
    const [message, setMessage] = useState(false);
    const formRef = useRef();
    const phoneEx = /\d{11}/
    //-----------------------------------------------------------------------
    const {value : enteredName ,hasError : nameInputIsInvalid , valueIsValid : enteredNameIsValid ,
        valueChangeHandler : nameInputChangeHandler , inputBlurHandler : nameInputBlurHandler , reset : resetNameInput} = useInput(value => value.trim() !=='') ;
    const {value : companyName ,hasError : companyNameIsInvalid , valueIsValid : companyNameIsValid ,
        valueChangeHandler : companyNameInputChangeHandler , inputBlurHandler : companyNameInputBlurHandler , reset : resetCompanyName} = useInput(value => value.trim() !=='') ;
    const {value : titleName ,hasError : titleNameIsInvalid , valueIsValid : titleNameIsValid ,
        valueChangeHandler : titleNameInputChangeHandler , inputBlurHandler : titleNameInputBlurHandler , reset : resetTitleName} = useInput(value => value.trim() !=='') ;
    const {value : phoneNumber ,hasError : phoneNumberIsInvalid , valueIsValid : phoneNumberIsValid ,
        valueChangeHandler : phoneNumberInputChangeHandler , inputBlurHandler : phoneNumberInputBlurHandler , reset : resetPhoneNumber} = useInput(value => value.trim() !=='' && phoneEx.test(value)) ;
    const {value : msg ,hasError : msgIsInvalid , valueIsValid : enteredMsgIsValid ,
        valueChangeHandler : msgChangeHandler , inputBlurHandler : msgBlurHandler , reset : resetMsg} = useInput(value => value.trim() !=='') ;
    const {value : enteredEmail ,hasError : emailInputIsInvalid , valueIsValid : enteredEmailIsValid ,
        valueChangeHandler : emailInputChangeHandler , inputBlurHandler : emailInputBlurHandler , reset : resetEmailInput} = useInput(value => value.includes('@')) ;
    //--------------------------------------------------
    const {value : enteredCon ,hasError : conInputIsInvalid , valueIsValid : enteredConIsValid,
      valueChangeHandler : conInputChangeHandler , inputBlurHandler : conInputBlurHandler, reset : resetConInput} = useInput(value => value.trim() !=='' && value.trim() !== '--Please Choose An Option--') ;
    //=======================================================
    const {value : enteredChannel ,hasError : channelInputIsInvalid , valueIsValid : enteredChannelIsValid,
      valueChangeHandler : channelInputChangeHandler , inputBlurHandler : channelInputBlurHandler, reset : resetChannelInput} = useInput(value => value.trim() !=='' && value.trim() !== '--Please Choose An Option--') ;
    //=======================================================
    const {value : enteredPro ,hasError : proInputIsInvalid , valueIsValid : enteredProIsValid,
      valueChangeHandler : proInputChangeHandler , inputBlurHandler : proInputBlurHandler, reset : resetProInput} = useInput(value => value.trim() !=='' && value.trim() !== '--Please Choose An Option--') ;
    //=======================================================
    let formIsValid = false
    if(enteredNameIsValid &&companyNameIsValid && titleNameIsValid && phoneNumberIsValid && enteredEmailIsValid  && 
      enteredConIsValid && enteredMsgIsValid && enteredChannelIsValid && enteredProIsValid){
    formIsValid = true;
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        if(!formIsValid){
            return;
        } ;
        emailjs.sendForm(
            'service_b56egkk',
            // 'template_ucdwaig',
            // order ?  'template_ucdwaig':'template_e0cntld',
            'template_e0cntld',
            formRef.current,
            '_x7rh3jMyIeDEdNTe').then(
            (result) => {
                console.log(result.text);
                setMessage(true);
            },
            (error) => {
                console.log(error.text);
            });
    
        e.target.reset();
        resetNameInput() ;
        resetEmailInput() ;
        resetCompanyName() ;
        resetTitleName();
        resetPhoneNumber();
        resetConInput();
        resetChannelInput();
        resetProInput();
        resetMsg() ;};
    //--------------------------------------------------
    const nameInputClasses = nameInputIsInvalid? `${classes["form-control"]} ${classes.invalid}` : `${classes["form-control"]}` ;
    const companyNameInputClasses = companyNameIsInvalid? `${classes["form-control"]} ${classes.invalid}` : `${classes["form-control"]}` ;
    const titleNameInputClasses = titleNameIsInvalid? `${classes["form-control"]} ${classes.invalid}` : `${classes["form-control"]}` ;
    const phoneNumberInputClasses = phoneNumberIsInvalid? `${classes["form-control"]} ${classes.invalid}` : `${classes["form-control"]}` ;
    const emailInputClasses = emailInputIsInvalid? `${classes["form-control"]} ${classes.invalid}` : `${classes["form-control"]}` ;
    const msgClasses = msgIsInvalid? `${classes["form-control"]} ${classes.invalid}` : `${classes["form-control"]}` ;
    const ConClasses = conInputIsInvalid? `${classes["form-control"]} ${classes.invalid}` : `${classes["form-control"]}` ;
    const channelClasses = channelInputIsInvalid? `${classes["form-control"]} ${classes.invalid}` : `${classes["form-control"]}` ;
    const proClasses = proInputIsInvalid? `${classes["form-control"]} ${classes.invalid}` : `${classes["form-control"]}` ;
    //----------------------------------------------------------

    return(
        <Container>
            <section className={`${classes.secpro} w-100`}>
            {/* <Row className={`g-5  p-4  justify-content-center`}>
                <Col className={`about-1st-row-col`}>
                <p className={`${classes.section__text__p1} text-center`}>Get In Touch</p>
                <p className={`fs-4 text-light fst-italic text-center`}>I do receive your messages and will respond ASAP if the valid email is provided :) </p>
                <h1 className={`${classes.title} w-100`}>Contact With Me</h1>
                </Col>
            </Row> */}
            <Row md={2} xs={1} lg={3} className={`g-5 p-md-3 gap-5  justify-content-center`}>
                <Col className={`${classes['contact-col']} d-flex flex-column justify-content-center`}>
                    <Row className={`overflow-hidden rounded-3 mt-2 mb-5 p-0`}>
                        <img src={contactImg} alt="contactImg" className={`img-fluid p-0`} loading="lazy"/>
                    </Row>
                    <Row><h1 className={classes.title}>Contact Us</h1></Row>
                    <Row><p className={`${classes["section__text__p2"]}`}><a href="/contact">Want to be a Reseller ?</a></p></Row>
                    <Row><p className={`${classes["section__text__p2"]}`}><a href="/order">Contact Sales</a></p></Row>
                    <Row><p className={`${classes["section__text__p2"]}`}><a href="/support">Contact Support</a></p></Row>
                    <Row><p className={`${classes['section__text__p1']} text-center`}>It would be a pleasure to hear from you</p></Row>
                    {order &&
                    <div className={`${classes["socials-container"]} w-100 d-flex justify-content-between m-2`}>
                        <FaPhoneAlt className={`${classes.icon} fs-5`} />
                        <Col className={`text-center`} >+20 02 25627494</Col>
                        {/*text-white-50 */}
                    </div>
                    }
                    {!order &&
                    <div className={`${classes["socials-container"]} w-100 d-flex justify-content-between m-2`}>
                        <FaPhoneAlt className={`${classes.icon} fs-5`} />
                        <Col className={`text-center`} >+201117000311</Col>
                        {/*text-white-50 */}
                    </div>
                    }
                    {order &&
                    <div className={`${classes["socials-container"]} w-100 d-flex justify-content-between m-2`}>
                        <FaWhatsapp className={`${classes.icon} fs-5`} onClick={()=>{window.open(whatsapp)}}/>
                        <Col className={`text-center`} >+20 127 777 3615</Col>
                    </div>
                    } 
                    {order &&     
                    <a href="mailto:sales@millensys.com" className={`${classes["form-btn"]} ${classes.email} p-2 w-100 d-flex justify-content-center align-items-center`}>sales@millensys.com</a>
                    }
                    {!order && <>
                    <a href="mailto:support@millensys.com" className={`${classes["form-btn"]} ${classes.email} p-2 w-100 d-flex justify-content-center align-items-center`}>support@millensys.com</a>
                    <a href="mailto:gulf.support@millensys.com" className={`${classes["form-btn"]} ${classes.email} p-2 w-100 d-flex justify-content-center align-items-center`}>gulf.support@millensys.com</a>
                    <a href="mailto:americas.support@millensys.com" className={`${classes["form-btn"]} ${classes.email} p-2 w-100 d-flex justify-content-center align-items-center`}>americas.support@millensys.com</a>
                    </>}
                    <div><p className={`${classes["section__text__p2"]} w-100 d-flex justify-content-center m-2`}>FIND US IN</p></div>
                    <div className={`${classes["socials-container"]} w-100 d-flex justify-content-center m-4`}>

                        <FaLinkedinIn className={classes.icon} onClick={()=>{window.open('https://www.linkedin.com/company/millensys-healthcare-technology/mycompany/')}} />
                        <FaYoutube className={classes.icon} onClick={()=>{window.open('https://www.youtube.com/channel/UCabeJIoEoaabD8CR4Scmg-g')}}  />
                        <FaFacebookF className={classes.icon} onClick={()=>{window.open('https://www.facebook.com/millensys/')}} />
                    </div>
                </Col>

                <Col  className={`${classes["contact-col"]} flex-fill`}>
                    <form ref={formRef} onSubmit={handleSubmit}>
                    <Col className={`d-flex flex-column justify-content-center  p-lg-4 align-items-center`}>
                        <Row className={`${nameInputClasses} d-flex flex-column align-items-center w-100`} >
                            <label htmlFor='f-name'>Name</label>
                            <input type='text' id='f-name' name="Name" placeholder="Your  Name" required
                            onChange={nameInputChangeHandler} value={enteredName} onBlur={nameInputBlurHandler} />
                            {nameInputIsInvalid && <p className={classes['error-text']}>Your name must not be empty</p>}
                        </Row>
                        <Row className={`${companyNameInputClasses} d-flex flex-column align-items-center w-100`}>
                            <label htmlFor='company-name'>Company Name</label>
                            <input type='text' id='company-name'  name="Company Name" placeholder="Your Company Name" required 
                            onChange={companyNameInputChangeHandler} value={companyName} onBlur={companyNameInputBlurHandler} />
                            {companyNameIsInvalid && <p className={classes['error-text']}>Company Name must not be empty</p>}
                        </Row>
                        <Row className={`${titleNameInputClasses} d-flex flex-column align-items-center w-100`}>
                            <label htmlFor='title-name'>Title</label>
                            <input type='text' id='title-name'  name="Title Name" placeholder="Your Title" required 
                            onChange={titleNameInputChangeHandler} value={titleName} onBlur={titleNameInputBlurHandler} />
                            {titleNameIsInvalid && <p className={classes['error-text']}>Title must not be empty</p>}
                        </Row>
                        <Row className={`${phoneNumberInputClasses} d-flex flex-column align-items-center w-100`}>
                            <label htmlFor='Phone-number'>Phone Number</label>
                            <input type='text' id='Phone-number'  name="Phone Number" placeholder="Your Phone Number" required 
                            onChange={phoneNumberInputChangeHandler} value={phoneNumber} onBlur={phoneNumberInputBlurHandler} />
                            {phoneNumberIsInvalid && <p className={classes['error-text']}>The Phone Number must not be empty</p>}
                        </Row>
                        <Row className={`${emailInputClasses} d-flex flex-column align-items-center w-100`}>
                                <label htmlFor='email'>E-Mail Address</label>
                                <input type='email' id='email' name="Email Address" placeholder="Your Email Address" required
                                onChange={emailInputChangeHandler} value={enteredEmail} onBlur={emailInputBlurHandler}/>
                                {emailInputIsInvalid && <p className={classes['error-text']}>please enter a valid email</p>}
                        </Row>
                        {/* ==================================================== */}
                        <Row className={`${ConClasses} d-flex flex-column align-items-center w-100`}>
                            <label htmlFor="country" >Country Name</label>
                            <select  defaultValue={"--Please Choose An Option--"}  id='country' name="country" value={enteredCon} required
                            onChange={conInputChangeHandler} onBlur={conInputBlurHandler}  className={enteredCon?classes.done:null}>
                                {range.map(item => {return <option value={item.name} key={item.code} >{item.name}</option>})}
                            </select>
                            {conInputIsInvalid && <p className={classes['error-text']}>Country Name must not be empty</p>}
                        </Row>
                        <Row className={`${channelClasses} d-flex flex-column align-items-center w-100`}>
                            <label htmlFor="ContactChannel" >Contact Channel</label>
                            <select  defaultValue={"--Please Choose An Option--"} id='ContactChannel' name="Contact Channel" value={enteredChannel} required
                            onChange={channelInputChangeHandler} onBlur={channelInputBlurHandler} className={enteredChannel?classes.done:null} >
                                {ContactChannel.map(item => {return <option value={item.name} key={item.code}>{item.name}</option>})}
                            </select>
                            {channelInputIsInvalid && <p className={classes['error-text']}>Contact Channel must not be empty</p>}
                        </Row>
                        <Row className={`${proClasses} d-flex flex-column align-items-center w-100`}>
                            <label htmlFor="products" >Products</label>
                            <select  defaultValue={"--Please Choose An Option--"}  id='products' name="Products" value={enteredPro} required
                            onChange={proInputChangeHandler} onBlur={proInputBlurHandler} className={enteredPro?classes.done:null} >
                                {Products.map(item => {return <option value={item.name} key={item.code}>{item.name}</option>})}
                            </select>
                            {proInputIsInvalid && <p className={classes['error-text']}>Products must not be empty</p>}
                        </Row>
                        {/* ==================================================== */}
                        <Row className={`${msgClasses} d-flex flex-column align-items-center w-100`}>
                                <label htmlFor='textArea'>Leave Your Message</label>
                                <textarea id='textArea' name="Message" cols="30" rows="7" placeholder="Your Message" required
                                onChange={msgChangeHandler} value={msg} onBlur={msgBlurHandler}/>
                                {msgIsInvalid && <p className={classes['error-text']}>Your Message Must Not Be Empty</p>}
                        </Row>
                        <Row className={`${classes["form-actions"]} d-flex flex-column align-items-center w-100 m-0`}>
                            <button disabled={!formIsValid} className={`${classes["form-btn"]} `}>{formIsValid?'Submit':'Kindly Fill Out The Required Fields'}</button>
                            {message && <span className={`text-success mt-3 fst-italic fs-6`}>Thanks For Your Feedback, We Will Contact You As Soon As Possible</span>}
                        </Row>
                    </Col>
                    </form>
                </Col>
            </Row>
            </section>
        </Container>
    )
}
export default Form